import { render, staticRenderFns } from "./OfferAggregatedLPCard.vue?vue&type=template&id=2548a7aa&scoped=true&"
import script from "./OfferAggregatedLPCard.vue?vue&type=script&lang=js&"
export * from "./OfferAggregatedLPCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548a7aa",
  null
  
)

export default component.exports